export default class ProductGTM {
  constructor(productInfo) {
    this.productInfo = productInfo;
  }

  getProductInfo() {
    const { affiliation, item_brand, customMarketID, eventName, name, price } = this.productInfo;
    const newStringID = String(customMarketID).replace('SZ_', '');
    const hasCategory = window.ItemCategories || [];

    const item = {
      affiliation,
      coupon: '',
      index: 0,
      item_brand: item_brand || '',
      item_category: hasCategory[0] || '',
      item_category2: hasCategory[1] || '',
      item_category3: hasCategory[2] || '',
      item_category4: hasCategory[3] || '',
      item_category5: hasCategory[4] || '',
      item_id: newStringID,
      item_name: name,
      item_variant: '',
      price,
      quantity: 1,
      promotion_name: eventName,
    };

    return item;
  }

  getProductPrice() {
    const { price } = this.productInfo;

    return price;
  }

  /**
   * 將推薦資料整理成 GA 要的格式
   * @param {object} payload - The payload containing the recommended data and item list name.
   * @param {array} payload.recommendedData - 推薦商品資料
   * @param {string} payload.itemListName - 推薦商品列表名稱
   * @returns {array} - GA 要的資料格式
   */
  static mapRecommendData(payload) {
    const { recommendedData, itemListName } = payload;

    const allRecommendArray = recommendedData.map((item, index) => {
      return {
        index,
        item_id: item.Colors[0].CustomMarketID.split('SZ')[0],
        item_name: item.Name,
        item_list_name: itemListName,
        price: item.SellPrice,
      };
    });

    return allRecommendArray;
  }

  /**
   * 將推薦資料整理成 GA 要的格式 (賣場相同分類)
   * @param {object} payload - The payload containing the recommended data and item list name.
   * @param {array} payload.recommendedData - 推薦商品資料
   * @param {string} payload.itemListName - 推薦商品列表名稱
   * @returns {array} - GA 要的資料格式
   */
  static mapRecommendDataByCategory(payload) {
    const { recommendedData, itemListName } = payload;

    const allRecommendArray = recommendedData.map((item, index) => {
      return {
        index,
        item_id: item.customMarketID.split('SZ')[0],
        item_name: item.name,
        item_list_name: itemListName,
        price: item.sellPrice,
      };
    });

    return allRecommendArray;
  }

  static mapRecommendViewData(recommendPayload) {
    const { itemListName, recommendData } = recommendPayload;
    const recommendArray = [];

    recommendData.forEach((recommendItem, index) => {
      const recommendObj = {
        index,
        item_id: recommendItem.Colors[0].CustomMarketID.split('SZ')[0],
        item_name: recommendItem.Name,
        item_list_name: itemListName,
        price: recommendItem.SellPrice,
        quantity: 1,
        affiliation: recommendItem.Colors[0].ColorName,
        item_brand: '',
        item_variant: '',
      };

      recommendArray.push(recommendObj);
    });

    return recommendArray;
  }

  /**
   * 使用分類去做推薦的推薦商品
   */
  static mapRecommendViewDataByCategory(recommendPayload) {
    const { itemListName, recommendData } = recommendPayload;

    const recommendArray = recommendData.map((item, index) => {
      let data = {
        index,
        item_id: item.customMarketID.split('SZ')[0],
        item_name: item.name,
        item_list_name: itemListName,
        price: item.sellPrice,
        quantity: 1,
        affiliation: item.color,
        item_brand: '',
        item_variant: '',
      };

      // 幣別
      if (window.PictureContainer.includes('squarebear')) {
        data = {
          ...data,
          price: item.sellPriceTW,
        };
      }
      return data;
    });
    return recommendArray;
  }

  /**
   * 使用條碼去做推薦的推薦商品
   */
  static mapRecommendViewDataByBarcode(recommendPayload) {
    const { itemListName, recommendData } = recommendPayload;
    const hasCategory = window.ItemCategories || [];

    const recommendArray = recommendData.map((item, index) => {
      return {
        index,
        item_id: item.CustomMarketID.split('SZ')[0],
        item_name: item.Name,
        item_list_name: itemListName,
        price: item.SellPrice,
        quantity: 1,
        affiliation: item.ColorName,
        item_brand: '',
        item_variant: '',
        item_category: hasCategory[0] || '',
        item_category2: hasCategory[1] || '',
        item_category3: hasCategory[2] || '',
        item_category4: hasCategory[3] || '',
        item_category5: hasCategory[4] || '',
      };
    });

    return recommendArray;
  }

  /**
   * 將推薦資料整理成 GA 要的格式 (條碼分類)
   * @param {object} payload - The payload containing the recommended data and item list name.
   * @param {array} payload.recommendedData - 推薦商品資料
   * @param {string} payload.itemListName - 推薦商品列表名稱
   * @returns {array} - GA 要的資料格式
   */
  static mapRecommendDataByBarcode(payload) {
    const { recommendedData, itemListName } = payload;

    const allRecommendArray = recommendedData.map((item, index) => {
      return {
        index,
        item_id: item.CustomMarketID.split('SZ')[0],
        item_name: item.Name,
        item_list_name: itemListName,
        price: item.SellPrice,
      };
    });

    return allRecommendArray;
  }
}
